module.exports = __webpack_public_path__ + "img/icon_zoom.fd9e1588.png";